const keyNumberItems = document.querySelectorAll('.uecc-key-numbers .item');

if (keyNumberItems.length > 0) {
    let ticking = false;
    let animationFrameId = null;

    // Initialize each item
    keyNumberItems.forEach((item) => {
        const fillTo = parseFloat(item.getAttribute('data-fill-to')) || 0;
        const numberElement = item.querySelector('.item__number');
        const targetNumber = parseFloat(numberElement?.getAttribute('data-target')) || 0;
        
        // Store initial values
        item._fillTo = fillTo;
        item._currentProgress = 0;
        item._targetProgress = 0;
        item._targetNumber = targetNumber;
        item._currentNumber = 0;
        item._numberReached = false;
        item._counterStarted = false;
        
        // Add class for large numbers to apply smaller font-size
        // Threshold depends on size variant: >99999 for size-large, >999 for default
        if (numberElement) {
            const isSizeLarge = item.closest('.uecc-key-numbers')?.classList.contains('size-large');
            const threshold = isSizeLarge ? 99999 : 999;
            if (targetNumber > threshold) {
                numberElement.classList.add('item__number--large');
            }
        }
        
        item.style.setProperty('--progress', '0deg');
        if (numberElement) {
            numberElement.textContent = '0';
        }
    });

    const updateFillProgress = () => {
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY || window.pageYOffset;

        keyNumberItems.forEach((item) => {
            if (!item._fillTo) return;

            const rect = item.getBoundingClientRect();
            const elementTop = rect.top + scrollY;
            const elementHeight = rect.height;
            const elementCenter = elementTop + elementHeight / 2;
            
            const animationStart = elementTop + elementHeight - windowHeight;
            const animationEnd = elementCenter - windowHeight / 2;
            const extendedRange = (animationEnd - animationStart) * 2;
            const extendedEnd = animationStart + extendedRange;
            const currentScroll = scrollY;
            
            let progress = 0;
            
            if (currentScroll >= animationStart && currentScroll <= extendedEnd) {
                if (extendedRange > 0) {
                    const scrolled = currentScroll - animationStart;
                    progress = Math.min(1, Math.max(0, scrolled / extendedRange));
                }
            } else if (currentScroll > extendedEnd) {
                progress = 1;
            }
            
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            
            const fillPercentage = item._fillTo / 100;
            const targetProgressDegrees = easedProgress * fillPercentage * 360;
            
            item._targetProgress = targetProgressDegrees;
            
            if (progress > 0 && !item._counterStarted && item._targetNumber > 0) {
                item._counterStarted = true;
            }
        });
        
        let needsUpdate = false;
        keyNumberItems.forEach((item) => {
            if (!item._fillTo) return;
            
            const currentProgress = item._currentProgress || 0;
            const targetProgress = item._targetProgress || 0;
            const difference = Math.abs(targetProgress - currentProgress);
            
            if (difference > 0.05) {
                needsUpdate = true;
                
                const smoothingFactor = 0.15;
                const newProgress = currentProgress + (targetProgress - currentProgress) * smoothingFactor;
                
                item._currentProgress = newProgress;
                
                const roundedDegrees = Math.round(newProgress * 100) / 100;
                
                item.style.setProperty('--progress', `${roundedDegrees}deg`);
            } else {
                item._currentProgress = targetProgress;
                item.style.setProperty('--progress', `${Math.round(targetProgress * 100) / 100}deg`);
            }
            
            if (item._counterStarted && !item._numberReached && item._targetNumber > 0) {
                const numberElement = item.querySelector('.item__number');
                if (numberElement) {
                    const currentNumber = item._currentNumber || 0;
                    const targetNumber = item._targetNumber;
                    const numberDifference = Math.abs(targetNumber - currentNumber);
                    
                    if (numberDifference > 0.01) {
                        needsUpdate = true;
                        
                        const numberSmoothingFactor = 0.04;
                        const newNumber = currentNumber + (targetNumber - currentNumber) * numberSmoothingFactor;
                        item._currentNumber = newNumber;
                        
                        const isWholeNumber = item._targetNumber % 1 === 0;
                        const displayNumber = isWholeNumber 
                            ? Math.round(newNumber) 
                            : Math.round(newNumber * 100) / 100;
                        
                        numberElement.textContent = displayNumber.toString();
                    } else {
                        const isWholeNumber = item._targetNumber % 1 === 0;
                        const finalNumber = isWholeNumber 
                            ? Math.round(item._targetNumber) 
                            : Math.round(item._targetNumber * 100) / 100;
                        item._currentNumber = item._targetNumber;
                        item._numberReached = true;
                        numberElement.textContent = finalNumber.toString();
                    }
                }
            }
        });
        
        if (needsUpdate) {
            animationFrameId = requestAnimationFrame(updateFillProgress);
        } else {
            animationFrameId = null;
        }
        
        ticking = false;
    };

    const onScroll = () => {
        if (!ticking) {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
                animationFrameId = null;
            }
            window.requestAnimationFrame(updateFillProgress);
            ticking = true;
        }
    };

    const onResize = () => {
        updateFillProgress();
    };

    // Initial calculation
    updateFillProgress();

    // Listen for scroll events
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
}